import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import "./static/css/react-bootstrap-table-all.min.css";
import "./static/css/react-select.min.css";
import styles from "./static/css/bootstrap.min.css";
import "antd/dist/antd.css";

import { HashRouter as Router, Route, Redirect, Switch } from "react-router-dom";
// import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Login from "./view/Login";
import Home from "./view/Home";
import Forbidden from "./static/js/Forbidden";
import NotFound from "./static/js/NotFound";


ReactDOM.render(<Router>
    <div>
        <Switch>
            <Route exact path="/login" component={Login}/>
            <Redirect exact from="/" to="/login" />
            <Redirect exact from="/dashboard" to="/home" />
            <Route path="/home" component={Home}/>
            <Route path="/portfolio_monitor" component={Home}/>
            <Route path="/portfolio_monitor_config" component={Home}/>
            <Route path="/forbidden" component={Forbidden}/>
            <Route component={NotFound} />
        </Switch>
    </div>
</Router>, document.getElementById("root"));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js